export default __webpack_public_path__ + "static/caption-03-kr-b74812a741892fd58694dfc4d81b20be.webp";